/**
 * 通用加载按钮组件。
 */

type LoadingButtonProps = {
	text: string;
	onSubmit: () => void;
	loading?: boolean;
	disabled?: boolean;
};

/**
 * 展示加载状态的按钮组件。
 * @param {LoadingButtonProps} props 组件参数
 */
const LoadingButton = ({
	onSubmit,
	text,
	loading = false,
	disabled,
}: LoadingButtonProps) => {
	return (
		<button
			type="button"
			className="btn btn-primary btn-sm"
			onClick={onSubmit}
			disabled={disabled}
		>
			{!loading ? (
				text
			) : (
				<span className="loading loading-spinner loading-xs"></span>
			)}
		</button>
	);
};

export default LoadingButton;
